module.exports = require("./fr-CG");